import React from "react";
import find from "lodash/find";
import Course from "./components/Course";
import Subscription from "./components/Subscription";
import { Quotation } from "../../../stores/CoursePreviewStore/Types";
import BillingInfo from "../BillingInfo";
import CardDetails from "../CardDetails";
import { BillingType, PaymentType, Priceable } from "../Types";
import { CompanyDetail, Country, UserDetail } from "../BillingInfo/Types";

interface Props {
  activeQuote: Quotation;
  quotes: Quotation[];
  billingType: BillingType;
  // category: string;
  companyDetails: CompanyDetail;
  countries: Country[];
  country: string;
  couponCode: string;
  courses: {
    key: string;
    value: string;
    label: string;
  }[];
  token: string;
  monthlySubsequentPayment: string;
  // isCourseError: boolean;
  isCurrentUserPresent: boolean;
  kind: string;
  // monthlySubsequentPayment: string;
  // path: string;
  paymentType: PaymentType;
  // planKey: string;
  priceable: Priceable;
  // quotes: Quotation[];
  refCode: string;
  selectedCourse: string;
  slug: string;
  // step: StepType;
  applyVoucher: (couponCode: string, refCode: string) => Promise<void>;
  handleChange: (key: string, value: any) => void;
  onCourseChange: (e: any, slug: string) => void;
  // refreshQuote: () => void;
  // refreshQuoteWithoutCoupon: (e: any) => void;
  userDetails: UserDetail;
  monthlyTotalAmount: string;
  communityUpgradeAmount: string;
}

const CheckoutForm: React.FC<Props> = ({
  billingType,
  companyDetails,
  countries,
  country,
  courses,
  selectedCourse,
  priceable,
  quotes,
  userDetails,
  handleChange,
  onCourseChange,
  activeQuote,
  applyVoucher,
  couponCode,
  paymentType,
  refCode,
  isCurrentUserPresent,
  token,
  kind,
  monthlySubsequentPayment,
  monthlyTotalAmount,
  communityUpgradeAmount,
  slug,
}) => {
  const isFreeCheckout = activeQuote?.amount <= 0;
  const isGiftCheckout = paymentType === "gift";
  const isLoadingGiftOrder = isGiftCheckout && !priceable;
  const isGiftCourse = isGiftCheckout && priceable?.type === "course";
  const isGiftSubscription = isGiftCheckout && priceable?.type === "pass";
  const isLifetimeCheckout = slug === "lifetime" || priceable?.is_lifetime;
  // Members who already hold a Pass are sold the discounted lifetime plan,
  // and are spoken to as members. Anyone else arrived from the pricing cards.
  const isMemberLifetime = isLifetimeCheckout && Boolean(priceable?.discounted);
  const showCourseCheckout = paymentType === "course" || isGiftCourse;
  const showSubscriptionCheckout =
    paymentType === "subscription" || isGiftSubscription;

  const subscriptionActiveQuote = () => {
    return find(quotes, (quote) => quote?.interval === "monthly");
  };

  return (
    <section className="form-side" aria-labelledby="checkout-heading">
      <h1 id="checkout-heading">
        {isMemberLifetime
          ? "Make your access permanent"
          : isLifetimeCheckout
            ? "Every course, for good"
            : "Complete your order"}
      </h1>
      {showCourseCheckout && (
        <Course
          courses={courses}
          selectedCourse={selectedCourse}
          priceable={priceable}
          activeQuote={activeQuote}
          quotes={quotes}
          subscriptionActiveQuote={subscriptionActiveQuote()}
          onCourseChange={onCourseChange}
          handleChange={handleChange}
          canChangeCourse={!isGiftCheckout}
        />
      )}

      {showSubscriptionCheckout && (
        <Subscription
          priceable={priceable}
          slug={slug}
          quotes={quotes}
          activeQuote={activeQuote}
          communityUpgradeAmount={communityUpgradeAmount}
          canChangeSubscription={!isGiftCheckout}
        />
      )}

      {!isFreeCheckout && (
        <div className="billing-info" id="billing-info">
          <BillingInfo
            isCurrentUserPresent={isCurrentUserPresent}
            country={country}
            selectedCourse={selectedCourse}
            paymentType={paymentType}
            priceable={priceable}
            slug={slug}
            countries={countries}
            handleChange={handleChange}
            userDetails={userDetails}
            companyDetails={companyDetails}
          />
        </div>
      )}

      <CardDetails
        token={token}
        paymentType={paymentType}
        slug={slug}
        kind={kind}
        applyVoucher={applyVoucher}
        couponCode={couponCode}
        monthlyTotalAmount={monthlyTotalAmount}
        monthlySubsequentPayment={monthlySubsequentPayment}
        activeQuote={activeQuote}
        priceable={priceable}
        refCode={refCode}
        userDetails={userDetails}
        companyDetails={companyDetails}
        billingType={billingType}
        handleChange={handleChange}
        isCurrentUserPresent={isCurrentUserPresent}
      />
    </section>
  );
};

export default CheckoutForm;
